@if (loading) {
    <div>
        <otb-loading-animation-dots [text]="message" [mode]="'dark'"></otb-loading-animation-dots>
    </div>
}
